import React, { Component } from "react";
import { invokeApig } from '../../libs/awsLib';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import AlertActions from './AlertActions';
import AlertDetail from './AlertDetail';

export default class ListAlert extends Component {
    constructor(props) {
        super(props);

        this.typeOptions = [
            { id: 'UNIT', label: 'Vehículo(s)'},
            { id: 'TAG', label: 'Grupo de vehículos'},
            { id: 'ALL', label: 'Todos los vehículos'}
        ];

        this.semaphoreOptions = [
            { id: 'RED', label: 'Rojo (grave)'},
            { id: 'YELLOW', label: 'Amarillo (moderado)'},
            { id: 'GREEN', label: 'Verde (leve)'}
        ];

        this.state = {
            isLoading: true,
            alerts: [],
            refresh: false
        };
    }
    async componentDidMount() {
        console.log('componentDidMount');
        try {
        	const results = await this.alerts();
        	this.setState({ alerts: results });
        } catch (e) {
//        	alert(e);
        }
        this.setState({ isLoading: false });
    }

    alerts() {
        return invokeApig({
            path: "/alert/find",
            method: "POST",
            body: {
                "page": 0,
                "size": 10
            }
        });
    }
    handleAlertSuccess = (message) => {
      this.props.onAlertSuccess(message);
      this.setState({ isLoading: true });
      this.componentDidMount();
    }
    handleAlertError = (message) => {
      this.props.onAlertError(message);
    }

    // componentWillReceiveProps(props) {
    //     if (props.refresh) {
    //         console.log('refresh');
    //         this.componentDidMount();
    //     }
    // }

    render(){
        const columns = [
        	{ Header: 'Nombre', accessor: 'nameAlert', Cell: row => <AlertDetail {...this.props} alertId={row.original.range} nameAlert={row.original.nameAlert}/> },
        	{ Header: 'Vehículos', accessor: 'type', Cell: row => { 
                return this.typeOptions.find(type => { return row.value.toUpperCase() === type.id }).label } 
            },
        	{ Header: 'Semáforo', accessor: 'semaphore', Cell: row => { 
                return this.semaphoreOptions.find(semaphore => { return row.value.toUpperCase() === semaphore.id }).label } 
            },
        	{ Header: 'Estado', accessor: 'status' },
        	{ Header: 'Creado', accessor: 'creationDate' },
        	{ Header: 'Actualizado', accessor: 'lastUpdateDate' },
        	{ Header: 'Acciones', accessor: '', filterable: false, Cell: row =>
    			<div>
    				<AlertActions {...this.props} alertId={row.original.range} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
				</div>
            }];

        if (this.state.refresh) {
            this.componentDidMount();
        }
        
        return(
            <ReactTable
            	loading={this.state.isLoading}
                data={this.state.alerts.Items}
                columns={columns}
                filterable
                noDataText='Ingrese alertas...'
            	loadingText='Listando...'
            	showPagination={false}
            	defaultPageSize={10}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/alert/ListAlert.js